import styled from "styled-components";
import { BottomImageProps, ContainerGridCssProps } from "./ContainerGrid.types";
import { devices } from "src/utils/styled/_variables.styled";

export const ContainerGridWrapper = styled.section<ContainerGridCssProps>`
	padding-block: ${(props) =>
		props.paddingBlock ? `${props.paddingBlock}px` : "0px"};
	background-color: ${(props) =>
		props.background ? props.background : "transparent"};

	.rango-container {
		.rango-container {
			width: 100%;
			max-width: unset;
			padding: unset;
		}
	}

	.rango-row {
		row-gap: 16px;
		position: relative;

		& > div {
			& > div {
				height: 100%;
			}
		}
	}
	.rango-row-12 {
		.new.section {
			grid-column-end: span 12;
		}
	}
	.rango-row-6 {
		.new.section {
			grid-column-end: span 6;
		}
	}
	.rango-row-4 {
		.new.section {
			grid-column-end: span 4;
		}
	}
	.rango-row-3 {
		.new.section {
			grid-column-end: span 3;
		}
	}
	.rango-row-2 {
		.new.section {
			grid-column-end: span 2;
		}
	}
	.rango-row-1 {
		.new.section {
			grid-column-end: span 1;
		}
	}

	.hideMobile {
		@media ${devices.mobile} {
			display: none;
		}
	}

	.sliderMobile {
		@media ${devices.mfTablet} {
			display: none;
		}
	}

	.slick-slider {
		margin-bottom: 40px;
	}

	.slick-track {
		display: flex !important;
	}

	.slick-slide {
		height: inherit !important;

		& > div {
			height: 100%;
		}
	}

	.slide__item__wrapper {
		padding: 0 10px;
		height: 100%;

		& > div {
			height: 100%;
		}
	}

	.rango-row-centered {
		justify-content: center;
		display: flex;
		gap: ${(props) => (props.gap ? `${props.gap}px` : "12px")};
		@media ${devices.mobile} {
			flex-direction: column;
		}

		.new.section {
			min-width: 200px;
		}
	}
`;

function handleBackgroundImage(image: string) {
	if (image) {
		return `url("${image}")`;
	}
	return "transparent";
}

export const BottomImage = styled.div<BottomImageProps>`
	width: 100%;
	height: 205px;
	background: ${(props) => handleBackgroundImage(props.mobile)} center bottom / contain;
	background-repeat: no-repeat;
	margin-top: 22px;

	@media ${devices.mfTablet} {
		background-image: ${(props) => handleBackgroundImage(props.tablet)};
		height: 354px;
		margin-top: -80px;
	}

	@media ${devices.mfDesktop} {
		background-image: ${(props) => handleBackgroundImage(props.desktop)};
		height: 393px;
		margin-top: -250px;
	}
`;
